import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MenuBar from "../MenuBar"; // ← le menu avec les onglets verts
import { apiFetch } from "../api";

import { useI18n } from "../i18n/I18nContext";

export default function BoisForm() {
  const { t, ui } = useI18n();

  const [options, setOptions] = useState({
    fournisseurs: [],
  });

  const location = useLocation();
  const [editing, setEditing] = useState(false);

  const today = new Date().toISOString().split("T")[0];
  const initialFormData = {
    Fournisseur: "",
    ReferenceFournisseur: "",
    PrixTotal: "",
    PrixKg: "",
    NumBidon: "",
    NoBatch: "",
    Masse: "",
    DatePeremption: "",
    DateReception: today,
    Certif: "",
    PN: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [message, setMessage] = useState("");
  const [messageColor, setMessageColor] = useState("#fff");
  const [submitting, setSubmitting] = useState(false);
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const [certifPdfFile, setCertifPdfFile] = useState(null);
  const [certifPdfKey, setCertifPdfKey] = useState("");
  const [certifPdfName, setCertifPdfName] = useState("");
  // états pour le popup d'impression
  const [printing, setPrinting] = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);
  const navigate = useNavigate();

  const onGoOptions = (type) => {
    setUpdateOpen(false);
    navigate(`/options/${type}`);
  };

  const confirmPrint = async () => {
    const n = 2;

    // Helper : transforme la date en YYMM
    const toYYMM = (val) => {
      if (!val) return "";
      const s = String(val).trim();
      let m;

      // dd/mm/yyyy -> YYMM
      if ((m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/))) {
        const mm = m[2],
          yy = m[3].slice(-2);
        return yy + mm; // ex: 02/10/2025 -> 25 + 10 -> 2510
      }

      // yyyy-mm-dd -> YYMM
      if ((m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/))) {
        const yy = m[1].slice(-2),
          mm = m[2];
        return yy + mm; // ex: 2025-10-02 -> 25 + 10 -> 2510
      }

      // si déjà 4 chiffres, inverse MMYY -> YYMM (si ça ressemble à un mois)
      if ((m = s.match(/^(\d{2})(\d{2})$/))) {
        const a = parseInt(m[1], 10),
          b = m[2];
        if (a >= 1 && a <= 12) return b + m[1]; // 1025 -> 2510
        return s; // probablement déjà YYMM
      }

      return s; // format inconnu : on laisse tel quel
    };

    // Construire PN (comme tu fais déjà)
    const pn = [
      formData.ReferenceFournisseur,
      toYYMM(formData.DateReception),
      formData.NoBatch,
      formData.NumBidon,
    ]
      .filter(Boolean)
      .join("_")
      .replace(/[^\p{L}\p{N}_]+/gu, "_")
      .replace(/_+/g, "_")
      .toUpperCase();

    if (!pn) {
      setMessage(
        "Renseigne d’abord les champs clés (Essence, Couleur, Coupe, Date, Fournisseur, Nom du lot, Nombre de lot).",
      );
      setMessageColor("#ffeb99");
      return;
    }

    try {
      setPrinting(true);
      // Ouvre un onglet contrôlé, charge le blob (PDF/PNG) et lance l’impression côté client
      await clientPrintFromApi({
        n,
        pn,
        date: formData.DateReception,
      });

      //setPrintOpen(false);
      setMessage(`✅ Document prêt à l'impression (${n} étiquette(s)).`);
      setMessageColor("#06f706ff");
    } catch (e) {
      setMessage(e.message || "Erreur réseau");
      setMessageColor("#fa0909ff");
    } finally {
      setPrinting(false);
    }
  };

  // Détecter si le navigateur est sur Android
  function isAndroid() {
    return /Android/i.test(navigator.userAgent || "");
  }

  async function clientPrintFromApi(bodyForApi) {
    // Ouvrir la fenêtre immédiatement (évite le blocage pop-up)
    const win = window.open("", "_blank");
    if (win) {
      win.document.write(`<!doctype html><title>Préparation…</title>
      <body style="margin:0;font:16px sans-serif">Préparation du document…</body>`);
      win.document.close();
    }

    // Tu as forcé PNG côté serveur, on garde PNG côté client
    const fmt = "PNG";
    const res = await apiFetch("/api/resine/labels/a4", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...bodyForApi, format: fmt, download: false }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.message || `HTTP ${res.status}`);
    }
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);

    const safePN = String(bodyForApi.pn || "QR")
      .replace(/[^\w\-]+/g, "_")
      .slice(0, 64);
    const fileName = `A4_${bodyForApi.n || 1}x_${safePN}.png`;

    // Si la popup est bloquée → téléchargement direct
    if (!win) {
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(blobUrl);
      return;
    }

    const ANDROID = isAndroid();

    // Viewer + barre d’actions (sur Android: pas d’auto-print)
    const html = `<!doctype html><html><head><meta charset="utf-8">
  <title>${fileName}</title>
  <style>
    html,body{height:100%;margin:0}
    #bar{position:fixed;inset:auto 0 0 0;background:#111;color:#fff;
         padding:8px;display:flex;gap:8px;align-items:center;z-index:10}
    #bar button,#bar a{background:#E6FF3E;color:#000;border:0;padding:8px 12px;
         font-weight:800;cursor:pointer;text-decoration:none}
    .viewer{position:fixed;left:0;right:0;top:0;bottom:44px;border:0;width:100%;
         height:auto;min-height:calc(100% - 44px);object-fit:contain;background:#fff}
  </style></head><body>
    <img class="viewer" src="${blobUrl}" alt="Étiquettes" />
    <div id="bar">
      ${ANDROID ? "" : "<button id='btnPrint'>Imprimer</button>"}
      <a id="btnDownload" href="${blobUrl}" download="${fileName}">Télécharger</a>
      <button id="btnClose">Fermer</button>
    </div>
    <script>
      ${ANDROID ? "" : "btnPrint.onclick = () => { try { window.focus(); window.print(); } catch(e){} };"}
      btnClose.onclick = () => { try { URL.revokeObjectURL("${blobUrl}"); } catch(e){}; setTimeout(()=>window.close(),100); };
      window.onafterprint = () => { try { URL.revokeObjectURL("${blobUrl}"); } catch(e){}; setTimeout(()=>window.close(),200); };
      // Auto-print uniquement hors Android
      ${ANDROID ? "" : "setTimeout(()=>{ try { window.focus(); window.print(); } catch(e){} }, 400);"}
    </script>
  </body></html>`;

    win.document.open();
    win.document.write(html);
    win.document.close();
  }

  // Récupérer le libellé (nom) depuis un code dans une liste d'options
  const nameFromCode = (list = [], code) => {
    const it = list.find(
      (x) => String(x.code).toUpperCase() === String(code || "").toUpperCase(),
    );
    return it ? it.nom : "";
  };

  // Canonicalise une chaîne: minuscule, sans accents, sans signes
  const canon = (s) =>
    String(s || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // supprime les accents
      .toLowerCase()
      .replace(/[^a-z0-9]/g, ""); // garde lettres/chiffres

  /**
   * Retourne le code (ex: "SGB") pour un nom donné (ex: "S&G").
   * @param {Array<{code:string, nom:string}>} list
   * @param {string} name
   * @returns {string} code ou "" si non trouvé
   */
  function getCodeByName(list, name) {
    if (!name) return "";
    const raw = String(name).trim();

    // 1) correspondance exacte (insensible à la casse)
    const exact = list.find(
      (x) =>
        String(x.nom || "")
          .trim()
          .toLowerCase() === raw.toLowerCase(),
    );
    if (exact) return exact.code;

    // 2) correspondance "canonique" (sans accents/signes)
    const ctarget = canon(raw);
    let hit = list.find((x) => canon(x.nom) === ctarget);
    if (hit) return hit.code;

    // 3) correspondance partielle (ex: "Deroules Champagne")
    hit = list.find(
      (x) => canon(x.nom).includes(ctarget) || ctarget.includes(canon(x.nom)),
    );
    return hit ? hit.code : "";
  }

  // ---- chargement des listes déroulantes
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiFetch(`/api/options`);
        if (!res.ok) throw new Error("Erreur serveur");
        const data = await res.json();
        if (!cancelled) {
          // compat: si l’API renvoie "coloris" au lieu de "couleurs"
          setOptions({
            fournisseurs: data.fournisseurs || [],
          });
          setOptionsLoaded(true); // ✅ on signale que les listes sont prêtes
        }
      } catch (e) {
        if (!cancelled) {
          setMessage("Impossible de charger les listes.");
          setMessageColor("#ffb3b3");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  // --- Pré-remplissage si on vient de "Modifier" depuis Consultation
  useEffect(() => {
    if (!optionsLoaded) return; // ✅ ne rien faire tant que les listes ne sont pas chargées
    const fromState = location.state && location.state.item;
    const fromStorage = !fromState
      ? JSON.parse(localStorage.getItem("woodoo_resine_edit_item") || "null")
      : null;
    const item = fromState || fromStorage;
    if (item) {
      // remettre le code du fournisseur
      item.Fournisseur = getCodeByName(options.fournisseurs, item.Fournisseur);
      // nettoie les valeurs undefined, conserve les clés existantes
      setFormData((prev) => ({ ...prev, ...item }));
      setCertifPdfKey(item.CertifPdfKey || "");
      setCertifPdfName(item.CertifPdfName || "");
      setCertifPdfFile(null);
      setEditing(true);
      localStorage.removeItem("woodoo_resine_edit_item");
    }
  }, [optionsLoaded, location.state]); // ✅ dépend aussi du flag

  useEffect(() => {
    if (!formData.DateReception) return;
    const d = new Date(formData.DateReception);
    if (isNaN(d)) return;
    d.setMonth(d.getMonth() + 6);
    const iso = d.toISOString().split("T")[0];
    if (iso !== formData.DatePeremption) {
      setFormData((p) => ({ ...p, DatePeremption: iso }));
    }
  }, [formData.DateReception]);

  function calcPrixTotal(prixKg, masse) {
    const p = Number(String(prixKg ?? "").replace(",", "."));
    const m = Number(String(masse ?? "").replace(",", "."));
    if (!Number.isFinite(p) || !Number.isFinite(m) || p <= 0 || m <= 0) return "";
    return String(Math.round(p * m * 100) / 100);
  }

  useEffect(() => {
    const total = calcPrixTotal(formData.PrixKg, formData.Masse);
    if (total !== formData.PrixTotal) {
      setFormData((p) => ({ ...p, PrixTotal: total }));
    }
  }, [formData.PrixKg, formData.Masse]);

  const handleChange = (e) => {
    setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));
  };

  const handleCertifPdfChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.type !== "application/pdf" && !file.name.toLowerCase().endsWith(".pdf")) {
      setMessage("Seuls les fichiers PDF sont acceptés.");
      setMessageColor("#fa0909ff");
      e.target.value = "";
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      setMessage("PDF trop volumineux (10 Mo max).");
      setMessageColor("#fa0909ff");
      e.target.value = "";
      return;
    }
    setCertifPdfFile(file);
    setCertifPdfName(file.name);
  };

  const extractPnFromMessage = (message) => {
    const m = String(message || "").match(/PN:\s*(\S+)/i);
    return m ? m[1] : "";
  };

  const uploadCertifPdf = async (pn) => {
    if (!certifPdfFile || !pn) return null;
    const fd = new FormData();
    fd.append("pdf", certifPdfFile);
    fd.append("pn", pn);
    const r = await apiFetch("/api/logistique/resine/upload-certif", { method: "POST", body: fd });
    const res = await r.json();
    if (!r.ok || res.status !== "success") {
      throw new Error(res.message || "Erreur upload PDF certification");
    }
    return res;
  };

  const openCertifPdf = async () => {
    if (!certifPdfKey) return;
    try {
      const r = await apiFetch(`/api/logistique/resine/download-certif?key=${encodeURIComponent(certifPdfKey)}`);
      if (!r.ok) throw new Error("Impossible d'ouvrir le PDF");
      const blob = await r.blob();
      window.open(URL.createObjectURL(blob), "_blank", "noopener,noreferrer");
    } catch (e) {
      setMessage(e.message || "Erreur ouverture PDF");
      setMessageColor("#fa0909ff");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage("");
    try {
      const payload = { ...formData };
      delete payload.CertifPdfKey;
      delete payload.CertifPdfName;
      if (!payload.PN) delete payload.PN;

      const url = editing ? "/api/resine/update" : "/api/resine/add";
      const r = await apiFetch(url, {
        method: editing ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await r.json();
      if (result.status !== "success") {
        setMessage(result.message || "Erreur");
        setMessageColor("#fa0909ff");
        return;
      }

      let pn = result.pn || formData.PN || extractPnFromMessage(result.message);
      let pdfKey = certifPdfKey;
      let pdfName = certifPdfName;

      if (certifPdfFile && pn) {
        const up = await uploadCertifPdf(pn);
        pdfKey = up.certif_pdf_key;
        pdfName = up.certif_pdf_name || certifPdfFile.name;
        const r2 = await apiFetch("/api/resine/update", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...payload,
            PN: pn,
            CertifPdfKey: pdfKey,
            CertifPdfName: pdfName,
          }),
        });
        const res2 = await r2.json();
        if (res2.status !== "success") {
          setMessage(res2.message || "PDF uploadé mais enregistrement incomplet");
          setMessageColor("#ffeb99");
        }
      }

      setFormData((prev) => ({ ...prev, PN: pn, CertifPdfKey: pdfKey, CertifPdfName: pdfName }));
      setCertifPdfKey(pdfKey);
      setCertifPdfName(pdfName);
      setCertifPdfFile(null);
      if (!editing) setEditing(true);

      setMessage(result.message || "Terminé");
      setMessageColor("#06f706ff");
    } catch (e) {
      setMessage(e.message || "Erreur réseau");
      setMessageColor("#ffb3b3");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={styles.page}>
      {" "}
      <MenuBar active="logistique" />
      <div style={styles.wrap}>
        {" "}
        <section style={styles.panel}>
          <div style={styles.panelTitle}>SUIVI DE RÉSINE</div>
          <div style={styles.card}>
            {" "}
            <div style={styles.tableHeader}>PARAMÈTRES</div>
            <div style={styles.formAndActions} className="formAndActions">
              <form onSubmit={handleSubmit} style={styles.form}>
                <Row label="DATE DE RÉCEPTION">
                  {" "}
                  <input
                    type="date"
                    name="DateReception"
                    value={formData.DateReception}
                    onChange={handleChange}
                    style={styles.input}
                  />{" "}
                </Row>
                <Row label="FOURNISSEUR">
                  <select
                    name="Fournisseur"
                    value={formData.Fournisseur}
                    onChange={handleChange}
                    style={styles.input}
                  >
                    <option value=""></option>{" "}
                    {options.fournisseurs.map((o) => (
                      <option key={o.code} value={o.code}>
                        {" "}
                        {o.nom}
                      </option>
                    ))}{" "}
                  </select>{" "}
                </Row>
                <Row label="RÉFÉRENCE FOURNISSEUR">
                  {" "}
                  <input
                    name="ReferenceFournisseur"
                    value={formData.ReferenceFournisseur}
                    onChange={handleChange}
                    style={styles.input}
                  />{" "}
                </Row>
                <Row label="N° BATCH">
                  {" "}
                  <input
                    name="NoBatch"
                    value={formData.NoBatch}
                    onChange={handleChange}
                    style={styles.input}
                  />{" "}
                </Row>
                <Row label="NUMÉRO DE BIDON">
                  <input
                    name="NumBidon"
                    value={formData.NumBidon}
                    onChange={handleChange}
                    style={styles.input}
                  />
                </Row>
                <Row label="DATE DE PÉREMPTION">
                  {" "}
                  <input
                    type="date"
                    name="DatePeremption"
                    value={formData.DatePeremption}
                    onChange={handleChange}
                    style={styles.input}
                  />{" "}
                </Row>
                <Row label="CONDITIONNEMENT (kg)">
                  {" "}
                  <input
                    type="number"
                    name="Masse"
                    value={formData.Masse}
                    onChange={handleChange}
                    style={styles.input}
                  />{" "}
                </Row>
                <Row label="PRIX / KG (€)">
                  {" "}
                  <input
                    type="number"
                    step="0.01"
                    name="PrixKg"
                    value={formData.PrixKg}
                    onChange={handleChange}
                    style={styles.input}
                  />{" "}
                </Row>
                <Row label="PRIX TOTAL (€)">
                  {" "}
                  <input
                    type="number"
                    step="0.01"
                    name="PrixTotal"
                    value={formData.PrixTotal}
                    readOnly
                    style={{ ...styles.input, background: "#e8e8e8", cursor: "default" }}
                    title="Calculé automatiquement : prix/kg × conditionnement"
                  />{" "}
                </Row>
                <Row label="CERTIFICATION">
                  <select
                    name="Certif"
                    value={formData.Certif}
                    onChange={handleChange}
                    style={styles.input}
                  >
                    <option value="">— Sélectionner —</option>
                    {["FSC", "PEFC", "Bois de France"].map((o) => (
                      <option key={o} value={o}>{o}</option>
                    ))}
                  </select>
                </Row>
                <Row label="CERTIFICAT PDF">
                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <input
                      type="file"
                      accept="application/pdf,.pdf"
                      onChange={handleCertifPdfChange}
                      style={{ ...styles.input, padding: "6px 8px", height: "auto" }}
                    />
                    {(certifPdfFile || certifPdfKey) && (
                      <div style={{ fontSize: 12, display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
                        <span>📄 {certifPdfFile?.name || certifPdfName || "certificat.pdf"}</span>
                        {certifPdfKey && !certifPdfFile && (
                          <button
                            type="button"
                            onClick={openCertifPdf}
                            style={{
                              background: "transparent",
                              border: "1px solid #E6FF3E",
                              color: "#000",
                              borderRadius: 4,
                              padding: "4px 10px",
                              cursor: "pointer",
                              fontSize: 11,
                              fontWeight: 700,
                            }}
                          >
                            Voir le PDF
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </Row>{" "}
              </form>
              <div style={styles.actions} className="actions">
                {" "}
                <button
                  onClick={handleSubmit}
                  disabled={submitting}
                  style={{
                    ...styles.btnAction,
                    background: "#fff",
                    color: "#000",
                  }}
                  className="btnAction"
                >
                  {" "}
                  {submitting
                    ? editing
                      ? "UPDATING..."
                      : "SAVING..."
                    : editing
                      ? "UPDATE"
                      : "SAVE"}{" "}
                </button>
                <button
                  onClick={confirmPrint}
                  disabled={printing}
                  style={{
                    ...styles.btnAction,
                    background: "#E6FF3E",
                    color: "#000",
                  }}
                  className="btnAction"
                >
                  {" "}
                  {printing ? "PRINTING..." : "PRINT"}{" "}
                </button>
                <button
                  onClick={() => setUpdateOpen(true)}
                  style={{
                    ...styles.btnAction,
                    background: "#fff",
                    color: "#000",
                  }}
                  className="btnAction"
                >
                  {" "}
                  UPDATE TABLE{" "}
                </button>{" "}
                {message && (
                  <div
                    style={{
                      whiteSpace: "pre-line",
                      marginTop: 10,
                      color: messageColor,
                      fontWeight: 700,
                    }}
                  >
                    {" "}
                    {message}{" "}
                  </div>
                )}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
          {updateOpen && (
            <div style={modalStyles.backdrop}>
              <div style={modalStyles.modal}>
                {" "}
                <div style={modalStyles.title}>
                  {" "}
                  Mettre à jour une table d’options{" "}
                </div>{" "}
                <div style={modalStyles.body}>
                  {" "}
                  <div style={{ display: "grid", gap: 10 }}>
                    <button
                      style={modalStyles.btnMenu}
                      onClick={() => onGoOptions("fournisseurs")}
                    >
                      {" "}
                      Fournisseurs{" "}
                    </button>{" "}
                  </div>
                </div>{" "}
                <div style={modalStyles.actions}>
                  {" "}
                  <button
                    onClick={() => setUpdateOpen(false)}
                    style={modalStyles.btnCancel}
                  >
                    {" "}
                    Fermer{" "}
                  </button>{" "}
                </div>{" "}
              </div>{" "}
            </div>
          )}{" "}
        </section>{" "}
      </div>{" "}
    </div>
  );
}

function Row({ label, children }) {
  return (
    <div style={styles.row} className="row">
      <div style={styles.cellLabel} className="cellLabel">
        {label}
      </div>
      <div style={styles.cellInput}>{children}</div>
    </div>
  );
}

/* ---------- Styles ---------- */
const LIME = "#E6FF3E";

const styles = {
  page: {
    minHeight: "100vh",
    background: "#000",
    color: "#fff",
    fontFamily:
      'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  wrap: {
    padding: "0 16px 36px",
  },
  panel: {
    background: "#63686f",
    border: "1px solid #3c4046",
    padding: 16,
    marginTop: 14,
    borderRadius: 6,
  },
  panelTitle: {
    color: "#fff",
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: 0.6,
    marginBottom: 10,
    fontSize: 15,
  },
  card: {
    background: "#e9eaed",
    border: "1px solid #c9cbd1",
    borderRadius: 6,
    overflow: "hidden",
  },
  tableHeader: {
    background: "#d8d9db",
    color: "#000",
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: 0.6,
    padding: "10px 16px",
    borderBottom: "1px solid #c9cbd1",
    fontSize: 14,
  },
  formAndActions: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 20,
    padding: 16,
  },
  form: {
    background: "#fff",
    border: "1px solid #c7c7c7",
    borderRadius: 4,
    overflow: "hidden",
  },
  row: {
    display: "grid",
    gridTemplateColumns: "1fr",
    borderBottom: "1px solid #d0d0d0",
  },
  cellLabel: {
    background: "#d0d2d5",
    color: "#000",
    fontWeight: 800,
    padding: "12px 10px",
    fontSize: 13,
    borderBottom: "1px solid #c0c0c0",
  },
  cellInput: {
    background: "#f4f5f7",
    padding: "8px 10px",
  },
  input: {
    width: "100%",
    height: 36,
    borderRadius: 4,
    border: "1px solid #c0c0c0",
    padding: "0 8px",
    fontSize: 14,
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    alignItems: "stretch",
  },
  btnAction: {
    height: 44,
    border: "none",
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: 0.6,
    cursor: "pointer",
    borderRadius: 4,
    fontSize: 14,
  },
};

/* ✅ Responsive media queries */
const mediaStyle = document.createElement("style");
mediaStyle.innerHTML = `
/* Tablette - 640px+ */
@media (min-width: 640px) {
  .wrap {
    padding: 0 24px 36px !important;
  }
  .formAndActions {
    gap: 24px !important;
  }
  .actions {
    gap: 14px !important;
  }
  .row {
    grid-template-columns: 1fr 2fr !important;
  }
  .cellLabel {
    border-bottom: none !important;
  }
}

/* Desktop small - 900px+ */
@media (min-width: 900px) {
  .wrap {
    padding: 0 40px 40px !important;
  }
  .formAndActions {
    grid-template-columns: 2fr 1fr !important;
  }
}

/* Desktop - 1024px+ */
@media (min-width: 1024px) {
  .wrap {
    padding: 0 80px 40px !important;
  }
  .actions {
    gap: 16px !important;
  }
}

/* Desktop large - 1280px+ */
@media (min-width: 1280px) {
  .wrap {
    padding: 0 120px 40px !important;
  }
}

/* Desktop XL - 1536px+ */
@media (min-width: 1536px) {
  .wrap {
    padding: 0 200px 40px !important;
  }
}

/* Touch targets pour mobile */
@media (max-width: 639px) {
  .btnAction {
    height: 48px !important;
    font-size: 13px !important;
  }
  input, select {
    height: 40px !important;
    font-size: 15px !important;
  }
}
`;
document.head.appendChild(mediaStyle);

const modalStyles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 50,
    padding: "20px",
  },
  modal: {
    width: "100%",
    maxWidth: 360,
    background: "#1f2937",
    color: "#fff",
    border: "1px solid #374151",
    borderRadius: 8,
    boxShadow: "0 10px 30px rgba(0,0,0,.4)",
  },
  title: {
    fontWeight: 800,
    padding: "14px 16px",
    borderBottom: "1px solid #374151",
    fontSize: 15,
  },
  body: {
    padding: 16,
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    padding: 12,
    borderTop: "1px solid #374151",
  },
  btnCancel: {
    background: "#fff",
    color: "#000",
    border: "none",
    padding: "10px 16px",
    cursor: "pointer",
    borderRadius: 4,
    fontWeight: 700,
    fontSize: 14,
  },
  btnMenu: {
    background: "#E6FF3E",
    color: "#000",
    border: "none",
    padding: "12px 16px",
    fontWeight: 800,
    cursor: "pointer",
    borderRadius: 4,
    fontSize: 14,
  },
};
